<template>
  <div class="flex layout-column" :style="{background: compColor.context.background}" style="position:absolute;top:0;left:0;right:0;bottom:0;">
    <div class="flex layout-column pa-lg-2 pa-md-2 lx-delivery-background">
      <ValidationObserver ref="DownloadDetailsForm"
                          class="layout-column">
        <v-card class="flex layout-row">
          <div class="flex layout-column">
            <v-progress-linear :indeterminate="true" v-if="isUploading" color="red accent-2"
                               background-color="red lighten-4" class="ma-0"
                               style="border-radius:0;height:4px;position: absolute;top:56px;left:0; width:100%;"></v-progress-linear>

            <form class="flex layout-column" ref="form">
              <div class="elevation-6 pa-1" style="z-index: 5;"
                   v-bind:class="[compColor.contentFrameBack]">
                <div class="pa-1" v-bind:class="[compColor.contentFrameFront]">
                  <v-btn :dark="compColor.isInDarkMode" :color="compColor.primeColor"
                         class="white--text text-none" @click="getData()">
                    <v-icon left dark>refresh</v-icon>
                    <span>{{ $t('buttons.refresh.value') }}</span>
                  </v-btn>
                </div>
              </div>

              <div class="pa-2 flex" style="overflow-y:auto;" v-bind:class="[compColor.contentFrameBack]">
                <downloads :showEditor="true" :showDialog="showPopup" ref="childComponent"></downloads>

                <!--  deletion dialog  -->

                <v-dialog v-model="deletionDialog" persistent width="20%" overlay-opacity="0.9">
                  <v-card class="flex" :dark="compColor.isInDarkMode"
                          v-bind:class="[compColor.contentFrameBack]">
                    <v-card-title class="title elevation-4 layout-row pa-0">
                      <div class="pa-1 flex" v-bind:class="[compColor.contentFrameBack]"
                           style="z-index: 2;border-radius:4px 4px 0 0;">
                        <div class="py-1 px-1 layout-row layout-align-start-center"
                             v-bind:class="[compColor.contentFrameFront,compColor.widget.headline]">
                          <div class="layout-column layout-align-center-center pr-3">
                            <v-avatar :color="compColor.avatarTile" tile height="40"
                                      width="40"
                                      style="min-width:40px;">
                              <v-icon :color="compColor.primeColor">delete_forever
                              </v-icon>
                            </v-avatar>
                          </div>
                          {{ $t('COMPONENT_DASHBOARD.CONFIRM_DELETE') }}
                        </div>
                      </div>
                    </v-card-title>
                    <v-divider v-bind:class="compColor.textInput"
                               v-if="compColor.isInDarkMode"></v-divider>
                    <v-card-text class="pa-5">
                      {{ $t('COMPONENT_DASHBOARD.CONFIRM_DELETE_QUESTION') }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <div class="layout-row" style="width:100%;">
                        <v-btn :dark="compColor.isInDarkMode"
                               class="white--text text-none mx-1 flex"
                               :color="compColor.primeColor" @click="deleteItem">
                          {{ $t('FORMS_DIVERSE.RADIO_GROUP_JNU.YES') }}
                        </v-btn>
                        <v-btn :dark="compColor.isInDarkMode"
                               class="white--text text-none mx-1 flex"
                               :color="compColor.primeColor" @click="deletionDialog = null">
                          {{ $t('FORMS_DIVERSE.RADIO_GROUP_JNU.NO') }}
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <!--  edit dialog (create folder, edit rights, upload file) -->

                <v-dialog
                  v-model="modal"
                  :max-width="method === 'upload' ? '1200px' : '600px'"
                  width="90%"
                  min-height="90%"
                  overlay-opacity="0.9"
                  @keydown.esc="closePopup"
                  persistent
                  :dark="compColor.isInDarkMode"
                  :color="compColor.primeColor"
                >
                  <v-card class="flex" :dark="compColor.isInDarkMode"
                          v-bind:class="[compColor.contentFrameBack]">
                    <v-card-title class="title elevation-4 layout-row pa-0">
                      <div class="pa-1 flex" v-bind:class="[compColor.contentFrameBack]"
                           style="z-index: 2;border-radius:4px 4px 0 0;">
                        <div class="py-1 px-1 layout-row layout-align-start-center"
                             v-bind:class="[compColor.contentFrameFront,compColor.widget.headline]">
                          <div class="layout-column layout-align-center-center pr-3">
                            <v-avatar :color="compColor.avatarTile" tile height="40"
                                      width="40"
                                      style="min-width:40px;">
                              <v-icon :color="compColor.primeColor"
                                      v-if="method==='edit'">settings
                              </v-icon>
                              <v-icon :color="compColor.primeColor" v-else>
                                mdi-file-upload
                              </v-icon>
                            </v-avatar>
                          </div>
                          <span v-if="options[method]">{{ options[method].title }}</span>
                        </div>
                      </div>
                    </v-card-title>
                    <v-divider v-bind:class="compColor.textInput"
                               v-if="compColor.isInDarkMode"></v-divider>

                    <!--  Create Folder  -->

                    <v-card-text class="pa-5" v-if="method === 'createFolder'">
                      <div>
                        <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :label="$t('COMPONENT_DASHBOARD.DIR_NAME')"
                          placeholder=" "
                          autofocus
                          outlined
                          hide-details
                          v-model="model.name"
                          :dense="denseFields"
                          v-on:keyup.enter="savePopup"
                        ></v-text-field>
                      </div>
                    </v-card-text>

                    <!--  Create Link  -->

                    <v-card-text class="pa-5" v-if="method === 'createLink'">
                      <div>
                        <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :label="$t('COMPONENT_DASHBOARD.LINK_NAME')"
                          placeholder=" "
                          autofocus
                          outlined
                          hide-details
                          v-model="model.name"
                          :dense="denseFields"
                        ></v-text-field>
                      </div>

                      <div>
                        <v-text-field
                          :dark="compColor.isInDarkMode"
                          :color="compColor.primeColor"
                          :label="$t('NEWS_DETAILS.ACTION_TYPES.LINK')"
                          placeholder="https://"
                          outlined
                          hide-details
                          v-model="model.link"
                          :dense="denseFields"
                        ></v-text-field>
                      </div>
                    </v-card-text>

                    <!--  upload document  -->

                    <v-card-text class="pt-3 px-0 pb-0" v-if="method === 'upload'">
                      <div>
                        <div class="pa-1 flex layout-column">
                          <fake-input-frame class="ma-3 px-3 layout-column"
                                            data-fake-orientation="layout-row"
                                            :label="$t('COMPONENT_DASHBOARD.DRAG_AND_DROP_AREA')">
                            <div class="layout-row flex py-2"
                                 @drop.prevent="addFilesByDragAndDrop" @dragover.prevent
                                 style="height: 100%;width: 100%;">
                              <div class="pa-2 layout-column flex"
                                   v-bind:class="{'blue-grey lighten-5' : !compColor.isInDarkMode,'blue-grey darken-3' : compColor.isInDarkMode}"
                                   style="border:1px dashed #526b77 !important;border-radius:10px;">

                                <div class="flex layout-column layout-align-center-center px-7 pb-2"
                                     style="position:relative;">
                                  <span class="subtitle-1 font-weight-light"
                                        v-bind:class="{'blue-grey--text text--darken-2': !compColor.isInDarkMode, 'blue-grey--text text--lighten-4': compColor.isInDarkMode}"
                                        style="text-align:center;">{{ $t('COMPONENT_DASHBOARD.INFO_DROP_FILE') }}</span>
                                  <span class="title font-weight-black blue-grey--text text--lighten-3 mb-1">{{ $t('OR') }}</span>

                                  <v-btn @click="openHiddenFileInput()" depressed
                                         :color="compColor.primeColor" dark
                                         class="text-none">
                                    {{ $t('COMPONENT_DASHBOARD.INFO_CHOOSE_FILE') }}
                                  </v-btn>
                                  <input type="file" hidden ref="hiddenFileInput"
                                         @change="addFilesByDialog"/>
                                </div>
                              </div>
                            </div>
                          </fake-input-frame>

                          <fake-input-frame class="mx-3 flex layout-column pa-4"
                                            :label="$t('COMPONENT_DASHBOARD.FILE_TO_UPLOAD')">

                            <v-simple-table class="mt-2 flex" fixed-header
                                            style="height:100%;width:100%;border: black 2px;min-height:200px;"
                                            :dark="compColor.isInDarkMode">
                              <template>
                                <thead>
                                  <tr>
                                    <th class="text-right" style="width:45px;"></th>
                                    <th class="text-left">{{ $t('ACTIVITIES.FILENAME') }}</th>
                                    <th class="text-left" style="width:110px;">{{ $t('COMPONENT_DASHBOARD.FILE_SIZE') }}</th>
                                    <th class="text-left">{{ $t('COMPONENT_DASHBOARD.VISIBILITY') }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(file, index) in files" :key="index">
                                    <td>
                                      <v-btn text icon @click="removeFileInUpload(file)"
                                             :title="$t('buttons.delete.value')">
                                        <v-icon>delete_forever</v-icon>
                                      </v-btn>
                                    </td>
                                    <td>{{ file.name }}</td>
                                    <td>{{ Math.round(file.size / 1000) }} kb</td>
                                    <td>
                                      <v-select
                                        class="ma-0"
                                        :color="compColor.primeColor"
                                        v-model="files[index].roles"
                                        :items="roles"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        :background-color="compColor.inputs"
                                        :dark="compColor.isInDarkMode"
                                        :placeholder="$t('COMPONENT_DASHBOARD.ALL')"
                                        outlined
                                        multiple
                                        dense
                                        hide-details>

                                        <template #item="{item, on, attrs}">
                                          <v-list-item v-on="on">
                                            <v-list-item-action>
                                              <v-simple-checkbox
                                                :value="attrs.inputValue"
                                                v-on="on"
                                                :color="compColor.primeColor"
                                                :dark="compColor.isInDarkMode"
                                                :ripple="false"
                                              ></v-simple-checkbox>
                                            </v-list-item-action>

                                            <v-list-item-content>
                                              <v-list-item-title>
                                                <label :style="{ color: attrs.inputValue ? compColor.primeColor : '#546E7A'}">{{ $t('DOWNLOADS.ROLES.' + item) }}</label>
                                              </v-list-item-title>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </template>

                                        <template #selection="item">
                                          {{ formatRoleListElement(item) }}
                                        </template>
                                      </v-select>

                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </fake-input-frame>
                        </div>
                      </div>
                    </v-card-text>

                    <!--  edit rights  -->

                    <v-card-text class="px-2 pt-2 pb-0" v-if="method === 'edit'">
                      <div>
                        <v-list
                          subheader
                          flat
                          multiple
                          class="my-1"
                        >
                          <v-subheader>{{ $t('COMPONENT_DASHBOARD.SELECT_PERMISSIONS') }}</v-subheader>
                          <v-divider class="mb-2"></v-divider>
                          <v-list-item
                            v-for="role in roles"
                            :key="role"
                          >
                            <v-checkbox
                              v-model="model.roles"
                              :label="$t('DOWNLOADS.ROLES.' + role)"
                              :color="compColor.primeColor"
                              :dark="compColor.isInDarkMode"
                              :value="role"
                              :value-comparator="comparator"
                              hide-details
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-list-item>
                        </v-list>
                      </div>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="px-2">
                      <div class="layout-row" style="width:100%;">
                        <v-btn v-if="method === 'upload'"
                               depressed
                               :dark="compColor.isInDarkMode"
                               class="flex white--text text-none"
                               :disabled="files.length <= 0"
                               :color="compColor.primeColor"
                               @click="upload">
                          <span v-if="options[method]">{{ options[method].saveBtn }}</span>
                        </v-btn>

                        <v-btn v-else-if="method === 'createLink'"
                               depressed
                               :dark="compColor.isInDarkMode"
                               class="flex white--text text-none"
                               :disabled="!model.name || model.name.length <= 0"
                               :color="compColor.primeColor" @click="createLink">
                          <span v-if="options[method]">{{ options[method].saveBtn }}</span>
                        </v-btn>

                        <v-btn v-else
                               depressed
                               :dark="compColor.isInDarkMode"
                               class="flex white--text text-none"
                               :disabled="!model.name || model.name.length <= 0"
                               :color="compColor.primeColor" @click="savePopup">
                          <span v-if="options[method]">{{ options[method].saveBtn }}</span>
                        </v-btn>
                        <v-btn depressed :dark="compColor.isInDarkMode" class="white--text text-none ml-2"
                               :color="'grey'" @click="closePopup">
                          {{ $t('buttons.cancel.value') }}
                        </v-btn>
                      </div>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </form>
          </div>
        </v-card>
      </ValidationObserver>
    </div>

    <!-- START: Ladeanimation, rotierende Kreise, ausgeführt wenn isUploading === true -->
    <div v-if="isUploading" class="layout-column layout-align-center-center"
         :style="{'background': compColor.isInDarkMode ? 'rgba(0,0,0,0.6)' : 'rgba(0,0,0,0.6)'}"
         style="border-radius:5px;position: absolute;left:0;right:0;top:0;bottom:0;backdrop-filter:blur(5px);z-index:9999999">
      <v-progress-circular
        :size="Math.round(9.175 * fontSize)"
        :width="Math.round(0.125 * fontSize)"
        rotate="90"
        :color="compColor.primeHighlightColor"
        indeterminate
        value="10"
      >
        <v-progress-circular
          :size="Math.round(8 * fontSize)"
          :width="Math.round(0.625 * fontSize)"
          :color="compColor.primeHighlightColor"
          indeterminate
          value="10"
        >
          <div class="layout-column layout-align-center-center white--text" style="height:100%;">
            <div class="layout-column layout-align-center-center" style="height: 30px;">
              <v-icon :size="Math.round(2.0 * fontSize)" color="#ffffff22">mdi-dots-horizontal</v-icon>
            </div>
            <div class="layout-column layout-align-center-center">
              <span class="ma-0 mb-n2 pa-0" style="font-weight: 100;"
                    :style="{'font-size': Math.round(0.86 * fontSize) + 'px'}">uploading</span>
              <h1 class="ma-0 mt-n1 mb-n1 pa-0" :style="{'font-size': Math.round(1.3 * fontSize) + 'px'}">Data</h1>
            </div>
            <div class="layout-column layout-align-center-center" style="height: 30px;">
              <v-icon :size="Math.round(2.0 * fontSize)" color="#ffffff22">mdi-dots-horizontal</v-icon>
            </div>
          </div>
        </v-progress-circular>
      </v-progress-circular>
    </div>
    <!-- END: Ladeanimation, rotierende Kreise, ausgeführt wenn isUploading === true -->
  </div>
</template>

<script>
import Downloads from '../../Dashboard/widgets/Downloads'
import axios from 'axios'

export default {
  components: {
    Downloads
  },
  name: 'DownloadsDetails',
  data () {
    return {
      isUploading: false,
      fontSize: 20,
      model: {},
      modal: false,
      deletionDialog: false,
      method: null,
      options: {
        'createFolder': { title: this.$t('COMPONENT_DASHBOARD.CREATE_DIR'), saveBtn: this.$t('buttons.create_folder.title') },
        'createLink': { title: this.$t('COMPONENT_DASHBOARD.CREATE_LINK'), saveBtn: this.$t('buttons.create_folder.title') },
        'upload': { title: this.$t('COMPONENT_DASHBOARD.UPLOAD_FILES'), saveBtn: this.$t('buttons.upload_document.title') },
        'edit': { title: this.$t('COMPONENT_DASHBOARD.EDIT_ROLES'), saveBtn: this.$t('buttons.save.value') }
      },
      files: [],
      payload: null,
      roles: []
    }
  },
  methods: {
    /**
     * Browser benutzen einen Dateidialog aus Button und Input, wenn man <input type="file"/> benutzte
     * da das hässlich ist versteckt man diesen und aktiviert es durch den Click eines Buttons der per ID oder Refs darauf zugreift
     *
     **/
    openHiddenFileInput () {
      this.$refs.hiddenFileInput.click()
    },

    /**
     * Wird bei onChange aufgerufen, wenn im Dateidialog Dateien ausgewählt werden
     * diese werden an Methode addFiles übergeben, wo sie zerlegt und aufbereitet werden
     *
     **/
    addFilesByDialog () {
      let file = this.$refs.hiddenFileInput
      if (file && file.files) {
        this.addFiles(file.files)
      }
    },

    /**
     * Wird bei drop-Event aufgerufen, wenn im Drag-and-Drop-Bereich Dateien fallengelassen wurden
     * diese werden an Methode addFiles übergeben, wo sie zerlegt und aufbereitet werden
     *
     **/
    addFilesByDragAndDrop (event) {
      if (this.isUploading) return

      this.addFiles(event.dataTransfer.files)
    },

    /**
     * Zerlegt die Files-Objekte des Browsers und pusht sie dann in das this.files Array, welches die Tabelle füllt
     *
     **/
    addFiles (files) {
      if (!files) return

      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...files]).forEach(fileElement => {
        this.files.push(fileElement)
      })
    },

    /**
     * Remove selected file from files-array in upload-dialog
     *
     * @param file
     */
    removeFileInUpload (file) {
      this.files = this.files.filter(fileElement => {
        return fileElement !== file
      })
    },

    /**
     * Upload selected document
     */
    upload () {
      if (this.isUploading) return
      this.isUploading = true

      let formData = new FormData()

      this.files.forEach((file, index) => {
        const name = 'file' + (index + 1).toString()

        formData.append(name, file)
        formData.append(name + '_path', this.payload || '')

        if (Array.isArray(file.roles) && file.roles.length > 0) {
          file.roles.forEach((role) => {
            formData.append(name + '_roles', role.toString())
          })
        }
      })

      axios.post('/document', formData, { headers: { 'content-type': 'multipart/form-data' } })
        .then(() => {
          this.files = []
          this.closePopup()
          this.$refs.childComponent.getDocuments()
        })
        .finally(() => {
          this.isUploading = false

          //reset file input um neue dateien hochladen zu können
          if (this.$refs['hiddenFileInput']) {
            this.$refs['hiddenFileInput'].value = ''
          }
        })
    },

    createLink () {
      const parts = [
        new Blob([this.model.link], {
          type: 'text/plain'
        })
      ]

      const newFile = new File(parts, 'link_' + this.model.name, {
        lastModified: new Date(),
        type: "text/plain"
      })
      this.files = [newFile]
      this.upload()
    },

    /**
     * Save changed permissions, triggered in function savePopup
     *
     * @param data The model
     */
    changeViewPermission (data) {
      this.closePopup()

      this.$http.post('/document/' + encodeURIComponent(data.prefix), data)
        .then((res) => {
          this.NotifySuccess(res)
          this.getData()
        })
        .catch(this.NotifyError)
    },

    /**
     * Close popup and trigger functions in dependency to action
     */
    savePopup () {
      let result = {}

      // save changed permissions
      if (this.method === 'edit') {
        // show confirm dialog, if no permission is selected
        if (this.model.roles.length === 0) {
          this.DialogConfirm(
            this.$t('COMPONENT_DASHBOARD.HINT'),
            this.$t('COMPONENT_DASHBOARD.INFO_IF_NO_RIGHT_IS_SET')
          )
            .then(() => {
              this.changeViewPermission(this.model)
            })

          return
        }

        return this.changeViewPermission(this.model)
      }

      if (this.method === 'createFolder') {
        result.name = this.model.name
      }

      this.$refs.childComponent.createFolder(result, this.payload)
      this.closePopup()
    },

    /**
     * Close popup after setting rights or create folder or upload
     */
    closePopup () {
      this.modal = false

      // reset popup values
      this.model = {}
      this.payload = null
      this.files = []

      if (this.$refs['hiddenFileInput']) {
        this.$refs['hiddenFileInput'].value = ''
      }
    },

    /**
     * Get documents in Downloads.vue
     */
    getData () {
      this.$refs.childComponent.getDocuments()
    },

    /**
     * Delete selected document, function in Downloads.vue
     */
    deleteItem () {
      this.deletionDialog = false
      this.$refs.childComponent.deleteItem(this.payload)
    },

    /**
     * Open popup to create folder, edit rights or upload file
     *
     * @param event
     * @param type
     * @param value The selected Element
     */
    showPopup (event, type, value) {
      event.preventDefault() // stop bubbling to top element
      event.stopPropagation() //stop full bubbling

      this.$http.get('/documents/permissions')
        .then(res => {
          if (res.data && res.data) {
            this.roles = res.data
          }
        })
        .finally(() => {
          this.method = type
          if (this.method === 'createFolder') {
            this.payload = value
            this.model = {}
            this.modal = true
          }

          if (this.method === 'createLink') {
            this.payload = value.prefix
            this.model = {}
            this.modal = true
          }

          if (this.method === 'upload') {
            this.payload = value.prefix
            this.modal = true
          }

          if (this.method === 'edit') {
            this.payload = value
            this.model = {
              name: value.name,
              prefix: value.prefix,
              roles: value.roles || []
            }
            this.modal = true
          }

          if (this.method === 'delete') {
            this.payload = value
            this.deletionDialog = true
          }
        })
    },

    /**
     * Compare roles in roles-array (checkbox with array as value)
     * @param a
     * @param b
     * @returns {boolean}
     */
    comparator (a, b) {
      return a === b
    },

    /**
     * Format text of selected role element in upload-popup
     *
     * @param elem
     * @returns {VueI18n.TranslateResult}
     */
    formatRoleListElement (elem) {
      let returnValue = this.$t('DOWNLOADS.ROLES.' + elem.item)

      if (elem.index > 0) {
        returnValue = ', ' + returnValue
      }
      return returnValue
    }
  }
}
</script>
